<ng-container *ngIf="activityService.showGuestFields">
  <app-activities-lite-guest-data [checkedNonDiningLocalTime]="checkedNonDiningLocalTime" [checkedDiningLocalTime]="checkedDiningLocalTime"
    [TimeSlotUnitInMinutes]="TimeSlotUnitInMinutes" [matchedContinousSlots]="matchedContinousSlots"
    [selectedActivity]="selectedActivityData" [customGuestFields]="customGuestFields"
    [editContactData]="editContactData" [notesOptions]="notesOptions" [promoCodeDetail]="promoCodeDetail"
    (guestData)="setGuestData($event)" (notesData)="setNotesData($event)"></app-activities-lite-guest-data>
</ng-container>
<ng-container *ngIf="!activityService.showGuestFields">
  <div class="page-title-section px-3 row m-0 pt-5 pb-4 flex-column" id="pageTitle">
    <div class="main-title main-theme-color d-flex text-uppercase justify-content-center text-center text-uppercase">
      {{!activityService.isDining ? (activityService.isNonDining ? activityService.selectedNonDining.RestaurantName :
      selectedActivityData?.Name) : activityService.selectedDining.RestaurantName}}
    </div>
    <div
      *ngIf="activityService.isDining && activityService.selectedDining.WidgetCustomization?.DisplayRestaurantAddress">
      <div
        class="pt-3 dining-location text-uppercase activity-title class-info__detail__location d-flex align-items-center justify-content-center text-center">
        <mat-icon class="mat-icon-color" aria-hidden="false" aria-label="location">location_on</mat-icon>
        &nbsp; {{activityService.selectedDining.Street1}}{{activityService.selectedDining.Street2}},
        {{activityService.selectedDining.City}}, {{activityService.selectedDining.Country}}
      </div>
    </div>

    <div *ngIf="activityService.isNonDining">
      <div
        class="pt-3 dining-location text-uppercase activity-title class-info__detail__location d-flex align-items-center justify-content-center text-center ">
        <mat-icon class="mat-icon-color" aria-hidden="false" aria-label="location">location_on</mat-icon>
        &nbsp; {{activityService.selectedNonDining.Street1}}{{activityService.selectedNonDining.Street2}},
        {{activityService.selectedNonDining.City}}, {{activityService.selectedNonDining.Country}}
      </div>
    </div>

    <div class="mt-3 sub-title secondary-theme-color d-flex justify-content-center text-center text-uppercase">
      {{(activityService.selectedDining.WidgetCustomization?.HeaderText ?
      activityService.selectedDining.WidgetCustomization?.HeaderText : 'selectYourDesiredSlot') | translate}}
    </div>
  </div>
  <div class="container">
    <div
      *ngIf="!isEdit && activityService.isDining && !activityService.selectedDining.WidgetCustomization?.AllowNewReservations && availableSpecialMeals.length > 0">
      <div class="col-12 d-flex flex-row justify-content-center align-items-center tab-view">
        <div matRipple matRippleCentered="true"
          class="d-flex text-uppercase activity-title justify-content-center align-items-center cursor sub-menu"
          (click)="specialMealReservation()"
          [ngClass]="showSpecialEvent ? 'sub-menu-selection' : 'sub-menu-unselected'">
          <div class="d-flex align-items-center">&nbsp;{{'specialEvent' | translate}}</div>
        </div>
        <div matRipple matRippleCentered="true"
          class="d-flex text-uppercase activity-title justify-content-center align-items-center cursor sub-menu"
          (click)="normalTableReservation(false, activityService.selectedDining?.MaxPartySize)"
          [ngClass]="!showSpecialEvent ? 'sub-menu-selection' : 'sub-menu-unselected'">
          <div class="d-flex align-items-center">&nbsp;{{'tableReservation' | translate}}</div>
        </div>
      </div>
    </div>
    <div *ngIf="activityService.isDining && activityService.selectedDining.WidgetCustomization?.SubHeaderText"
      class="p-3 col-12 dining-main-title mt-4 mb-2 activity-description-bolder activity-description-dining text-uppercase">
      {{(activityService.selectedDining.WidgetCustomization?.SubHeaderText ?
      activityService.selectedDining.WidgetCustomization?.SubHeaderText : 'letsMakeReservation') | translate }}
    </div>

    <div *ngIf="activityService.isNonDining"
      class="p-3 col-12 dining-main-title mt-4 mb-2 activity-description-bolder text-uppercase">
      {{(activityService.selectedDining.WidgetCustomization?.SubHeaderText ?
      activityService.selectedDining.WidgetCustomization?.SubHeaderText : 'letsMakeReservation') | translate }}
    </div>

    <div *ngIf="activityService.isDining && showSpecialEvent && availableSpecialMeals.length > 0 && !activityService?.mealWithConfig"
      class="px-2 col-12 d-flex justify-content-end">
      <div class="activity-description d-flex align-items-center">
        <span class="icon-payments_FILL0_wght400_GRAD0_opsz48-1"></span> &nbsp;{{'prePaymentNeeded' | translate}}
      </div>
    </div>

    <div class="selected-meal-view" *ngIf="activityService.mealWithConfig && activityService.isDining">
      <img *ngIf="this.activityService.mealWithConfig?.ImageUrl" class="meal-image" [src]="this.activityService.mealWithConfig?.ImageUrl" alt="meal-image">
      <div class="meal-container">
        <div class="meal-header">
          <div><span class="meal-name">{{this.activityService.mealWithConfig?.Name || ''}}</span>
            <span class="meal-size" >&nbsp;({{'serves'| translate}} {{this.activityService.mealWithConfig?.MinPartySize}} -
              {{this.activityService.mealWithConfig?.MaxPartySize}})</span>

          </div>

          <div *ngIf="this.activityService.mealWithConfig?.DoesRequirePrepayment"
            class="d-flex special-meal-payment-required align-items-center font-weight-bold ">
            <span class="icon-payments_FILL0_wght400_GRAD0_opsz48-1"></span>&nbsp;{{'prePaymentNeeded' | translate}}
          </div>
        </div>
        <div *ngIf="activityService.mealWithConfig?.CoverTypePrices.length == 0 && this.activityService.mealWithConfig?.Price" >
          <span class="meal-price">{{this.activityService.mealWithConfig?.OperationCurrency + ' ' + (this.activityService.mealWithConfig?.Price | currencyDecimalFormatter)}}</span>
        </div>
        <div *ngIf="activityService.mealWithConfig?.CoverTypePrices.length > 0"
          class="d-flex cursor-pointer activity-description activity-list-title disable-text-select">
          <span (click)="$event.stopPropagation()" placement="bottom" [ngbPopover]="popContent">{{'viewPricing'
            | translate}}</span>
        </div>
        <ng-template #popContent>
          <div class="price-popover activity-description-bolder"
            *ngFor="let coverPrice of activityService.mealWithConfig?.CoverTypePrices">
            {{coverPrice.CoverTypeName + ' - ' +
            activityService.mealWithConfig.OperationCurrency + ' ' + (coverPrice.Price | currencyDecimalFormatter)}}
          </div>
        </ng-template>
        <p *ngIf="this.activityService.mealWithConfig?.Description" [innerHTML]="this.activityService.mealWithConfig?.Description | safeHtml">


        </p>
      </div>

    </div>

    <div *ngIf="activityService.isDining && showSpecialEvent && availableSpecialMeals.length > 0 && !this.activityService.mealWithConfig">
      <div class="col-12">
        <div class="py-2 d-flex flex-wrap justify-content-center">
          <ng-container *ngFor="let specialMeal of availableSpecialMeals; let i=index;">
            <div class="p-2 col-xl-3 col-md-4 col-12" (click)="selectSpecialMeal(i , true)">
              <div class="special-meal-container p-2 d- flex flex-column align-items-center"
                [ngClass]="{'special-meal-selected': specialMeal.Id === selectedActivityData?.Id}">
                <div class="d-flex justify-content-center position-relative">
                  <div class="text-uppercase text-truncate activity-title text-center">{{specialMeal?.Name}}
                  </div>
                  <div *ngIf="specialMeal?.DoesRequirePrepayment"
                    class="d-flex special-meal-payment-required align-items-center position-absolute">
                    <span class="icon-payments_FILL0_wght400_GRAD0_opsz48-1"></span>
                  </div>
                </div>
                <div class="activity-description text-center">{{('serves' | translate) + ' ' + specialMeal?.MinPartySize
                  + ' - ' +
                  specialMeal?.MaxPartySize + ' ' + ('people' | translate)}}</div>
                <div *ngIf="specialMeal?.CoverTypePrices.length > 0"
                  class="d-flex justify-content-center activity-description activity-list-title disable-text-select">
                  <span (click)="$event.stopPropagation()" placement="bottom" [ngbPopover]="popContent">{{'viewPricing'
                    | translate}}</span>
                </div>
                <div *ngIf="specialMeal?.CoverTypePrices.length === 0 && specialMeal?.Price"
                  class="dining-starting-price activity-description disable-text-select text-center">{{
                  selectedActivityData.OperationCurrency + ' ' + (specialMeal?.Price | currencyDecimalFormatter)}}</div>
                <ng-template #popContent>
                  <div class="price-popover activity-description-bolder"
                    *ngFor="let coverPrice of specialMeal?.CoverTypePrices">
                    {{coverPrice.CoverTypeName + ' - ' +
                    selectedActivityData.OperationCurrency + ' ' + (coverPrice.Price | currencyDecimalFormatter)}}
                  </div>
                </ng-template>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>

    <div class="row" *ngIf="!activityService.isDining && !activityService.isNonDining">
      <div class="session-filter-portion mt-4 col-lg-3 col-md-12 col-sm-12 col-12 d-flex flex-column">
        <ng-container  *ngTemplateOutlet="bookingTypeFilter"></ng-container>
        <ng-container *ngIf="selectedActivityData?.AllowInstructorSelectionForActivity">
          <mat-form-field appearance="outline">
            <mat-select placeholder="{{'SelectaInstructor' | translate}}" [value]="0" [(ngModel)]="currentInstructors">
              <mat-option [value]="eacInstructor.id" *ngFor="let eacInstructor of instructorList;">
                {{eacInstructor.value}}</mat-option>
            </mat-select>
          </mat-form-field>
        </ng-container>

        <ng-container *ngIf="activityService?.ConfigSettings?.AllowLocationSelectionForActivity">
          <mat-form-field appearance="outline">
            <mat-select [value]="0" placeholder="{{'SelectaLocation' | translate}}" [(ngModel)]="currentLocations"
              (onSelectionChange)="checkSessionorSlotAvailability(false, true)">
              <mat-option [value]="eacLoc.id" *ngFor="let eacLoc of locationList;">{{eacLoc.value}}</mat-option>
            </mat-select>
          </mat-form-field>
        </ng-container>

        <mat-form-field appearance="outline">
          <mat-label>{{(isMultiSlotSelection ? 'FromDate' : 'selectDate') | translate}}</mat-label>
          <input matInput placeholder="{{(isMultiSlotSelection ? 'FromDate' : 'selectDate') | translate}}" readonly
            [max]="bookingTypeMaxDate ? bookingTypeMaxDate  : (!activityService.isDining ? selectedActivityData?.EndDate : diningMaxDate)"
            [min]="bookingTypeMinDate ? bookingTypeMinDate : activityService.currentDateTime" [matDatepicker]="frompicker" [(ngModel)]="currentFromDate"
            (dateChange)="changeFromDate();checkSessionorSlotAvailability(false, true)" [disabled]="disableDatePicker">
          <mat-datepicker-toggle class="activity-date-selector-toggle" matSuffix [for]="frompicker">
          </mat-datepicker-toggle>
          <mat-datepicker #frompicker></mat-datepicker>
        </mat-form-field>

        <ng-container *ngIf="isMultiSlotSelection">
          <mat-form-field appearance="outline">
            <mat-label>{{'ToDate' | translate}}</mat-label>
            <input matInput placeholder="{{'ToDate' | translate}}" readonly [max]="bookingTypeMaxDate ? bookingTypeMaxDate : selectedActivityData?.EndDate"
              [min]="bookingTypeMinDate ? bookingTypeMinDate : currentFromDate" [matDatepicker]="topicker" [(ngModel)]="currentToDate"
              (dateChange)="checkSessionorSlotAvailability(false, true)">
            <mat-datepicker-toggle class="activity-date-selector-toggle" matSuffix [for]="topicker">
            </mat-datepicker-toggle>
            <mat-datepicker #topicker></mat-datepicker>
          </mat-form-field>
        </ng-container>

        <ng-container *ngIf="!activityService.isDining">
          <size-mapping [coverTypes]="coverTypes" [bookingTypes]="bookingTypes" [maxSize]="maxSizeAllowed" [(size)]="sizeMapping" (sizeChange)="bookingSizeChange()" [dataCovers]="selectedActivityData?.CoverTypeQuantities || []" [dataSize]="currentBookingSize" [isEdit]="isEdit"></size-mapping>
        </ng-container>

        <!-- <ng-container *ngIf="!activityService.isDining && bookingTypes?.length ===0 && coverTypes?.length ===0">
          <mat-form-field appearance="outline">
            <mat-label>{{'SelectCoverSize' | translate}}</mat-label>
            <mat-select [(ngModel)]="currentBookingSize" name="genericCoverSize"
              placeholder="{{'SelectCoverSize' | translate}}"
              (ngModelChange)="checkSessionorSlotAvailability(false, true)">
              <mat-option [value]="0">{{'0' | translate}}</mat-option>
              <mat-option [value]="bookingSize.id" *ngFor="let bookingSize of bookingSizeArray;">{{bookingSize.value}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </ng-container>

        <ng-container *ngFor="let bookType of bookingTypes;let i=index;">
          <mat-form-field appearance="outline">
            <mat-label>{{bookType.name}}</mat-label>

            <input type="text" [(ngModel)]="bookType.value" name="bookType_{{i}}" placeholder="{{bookType.name}}"
              (ngModelChange)="checkSessionorSlotAvailability(false, true)" matInput [matAutocomplete]="auto">
            <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
              <mat-option [value]="0">{{'0' | translate}}</mat-option>
              <mat-option [value]="bookingSize.id" *ngFor="let bookingSize of bookingSizeArray;">
                {{bookingSize.value}}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </ng-container>

        <ng-container *ngFor="let cover of coverTypes;let i=index;">
          <mat-form-field appearance="outline">
            <mat-label>{{cover.name}}</mat-label>


            <input type="number" [(ngModel)]="cover.value" name="cover_{{i}}" placeholder="{{cover.name}}"
              (ngModelChange)="checkSessionorSlotAvailability(false, true)" matInput [matAutocomplete]="auto">
            <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
              <mat-option [value]="0">{{'0' | translate}}</mat-option>
              <mat-option [value]="bookingSize.id" *ngFor="let bookingSize of bookingSizeArray;">
                {{bookingSize.value}}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </ng-container> -->


        <ng-container *ngTemplateOutlet="notesDisplayContent"></ng-container>

      </div>



      <ng-container *ngFor="let sessionDates of sessionSlotsAvailableDates; let i= index">
        <div class="col-lg-9 col-md-12 col-sm-12 col-12" *ngIf="selectedIndex === i">
          <div class="activity-date-tab mt-4 p-3 d-flex activity-description-bolder justify-content-around">
            <div *ngIf="sessionSlotsAvailableDates.length > 1" class="select-prev-date" [class.disabledArrow]="i === 0"
              (click)="loadPreviousDate(i)">&#60; </div>
            <div class="selected-date">{{sessionDates.AvailableDate | localizeDate : 'DD MMMM, ddd'}}</div>
            <div *ngIf="sessionSlotsAvailableDates.length > 1" class="select-next-date" (click)="loadNextDate(i)"
              [class.disabledArrow]="i === (sessionSlotsAvailableDates.length-1)">&#62;</div>
          </div>
          <div class="activity-date-slots mt-2 py-2 slots-view">
            <ng-container
              *ngFor="let eachSlot of sessionSlotsAvailableDates[selectedIndex]?.AvailableSessions; let i= index">
              <div class="p-2 " *ngIf="!eachSlot.pastSlot"
                [class.slot-disabled]="eachSlot.disabled || eachSlot.disabledOverlaped || !eachSlot.isAddonAvailable">
                <div (click)="slotChangeListners(eachSlot);"
                  class="activity-time-slot p-2 d-flex flex-column align-items-center position-relative"
                  [ngClass]="{'activity-time-slot-selected': eachSlot.isChecked === true}">
                  <!-- Session with count - Disabled for future requirement *ngIf="false"-->
                  <div *ngIf="false" class="session-slot__session-name" title="{{'Session' | translate}} {{i+1}}">
                    {{'session' | translate}} {{i+1}}</div>
                  <!-- Session with count - Disabled for future requirement *ngIf="false"-->
                  <div *ngIf="false" class="session-number activity-description">
                    {{eachSlot.SessionGroupName}}</div>
                  <div class="time-duration activity-description-bold">{{eachSlot.Start | localizeDate: 'LT'}}
                    <span *ngIf="false"> - {{eachSlot.End | localizeDate: 'LT'}}</span>
                  </div>

                  <div [class.slot-disabled]="eachSlot.disabled || eachSlot.disabledOverlaped" [ngClass]="eachSlot.showAvailibility.status === 0 || eachSlot.showAvailibility.status === 2 ? 'count-left-more' :
                                                  eachSlot.showAvailibility.status === 1 ? 'count-left-limited' :
                                                  eachSlot.showAvailibility.status === 2 || eachSlot.showAvailibility.status === 3 
                                                  || eachSlot.showAvailibility.status === 5 ? 'count-left-less' : ''"
                    class="activity-description-bold">
                    {{eachSlot.showAvailibility.text}}</div>
                  <div class="activity-notes" *ngIf="eachSlot.sessionHeadlines">
                    <i class="icon-info-with-circle"></i>
                    <span [matTooltip]="eachSlot.sessionHeadlines">{{ eachSlot.sessionHeadlines }}</span>
                  </div>
                  <div *ngIf="eachSlot.isChecked" class="position-absolute slot-selected-container">
                    <mat-icon class="mat-icon-color session-select-mat-icon">check_circle</mat-icon>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
          <div class="activity-date-slots mt-2 p-2 align-items-center slots-view">
            <mat-checkbox *ngIf="isMultiSlotSelection && isSessionClass 
            && sessionSlotsAvailableDates?.length 
            && sessionSlotsAvailableDates[selectedIndex]?.AvailableSessions 
            && sessionSlotsAvailableDates[selectedIndex]?.AvailableSessions?.length"
              (change)="applyToOtherDates(selectedIndex, $event)" [checked]="bookAllAvailableDates">
              <span class="px-3 activity-description-bold">
                {{'Bookforallavailabledates' | translate}} (
                <span class="date-text">
                  {{sessionSlotsAvailableDates[0]?.AvailableDate | localizeDate: 'DD MMMM'}} -
                  {{sessionSlotsAvailableDates[sessionSlotsAvailableDates.length -1].AvailableDate | localizeDate: 'DD
                  MMMM'}}
                </span>
                )
              </span>
            </mat-checkbox>
          </div>
        </div>
      </ng-container>
      <div
        class="col-lg-9 col-md-12 col-sm-12 col-12 no-slots-message activity-no-data-error activity-description-bolder d-flex justify-content-center align-items-center"
        *ngIf="!activityService.isDining && !activityService.loaderRunning && (!sessionSlotsAvailableDates || sessionSlotsAvailableDates?.length === 0) && ((isSessionClass 
                                    && (!sessionSlotsAvailableDates[selectedIndex]?.AvailableSessions 
                                    || (sessionSlotsAvailableDates[selectedIndex]?.AvailableSessions 
                                    && sessionSlotsAvailableDates[selectedIndex]?.AvailableSessions.length === 0))) 
                                    || (!isSessionClass && (!classLessonList || (classLessonList?.length === 0))))">
        {{'noSlotsAvailable' | translate}}
      </div>
    </div>

    <div class="row" *ngIf="activityService.isDining">
      <div class="col-12 mt-4 d-flex flex-wrap">
        <div class="col-lg-4 col-md-12 d-flex flex-column">
          <ng-container  *ngTemplateOutlet="bookingTypeFilter"></ng-container>
          <div class="dining-input-options p-2 mb-3 d-flex justify-content-center">
            <div class="px-3 d-flex align-items-center cursor dining-select-prev-date disable-text-select"
              (click)="changeDiningDate('prev')"
              [class.disabledArrow]="currentFromDate <= activityService.currentDateTime">&#60;</div>
            <div class="d-flex flex-column">
              <div class="dining-input-placeholder activity-description-bolder text-uppercase text-center">
                {{'selectDate' | translate}}</div>
              <div class="cursor dining-selected-data activity-description text-center select-date-text-decoration"
                (click)="frompicker.open()">
                {{currentFromDate | localizeDate : 'DD MMMM, ddd'}}</div>
              <mat-form-field appearance="outline" style="width:160px;height:1px;visibility: hidden;">
                <mat-label>{{'selectDate' | translate}}</mat-label>
                <input matInput placeholder="{{'selectDate' | translate}}" readonly [max]="bookingTypeMaxDate ? bookingTypeMaxDate : diningMaxDate"
                  (dateChange)="changeFromDate();checkSessionorSlotAvailability(false, true)"
                  [min]="bookingTypeMinDate ? bookingTypeMinDate : activityService.currentDateTime" [matDatepicker]="frompicker" [(ngModel)]="currentFromDate"
                  [matDatepickerFilter]="showParticularDays" [disabled]="disableDatePicker">
                <mat-datepicker-toggle class="activity-date-selector-toggle" matSuffix [for]="frompicker">
                </mat-datepicker-toggle>
                <mat-datepicker #frompicker></mat-datepicker>
              </mat-form-field>
            </div>
            <div class="px-3 d-flex align-items-center cursor dining-select-next-date disable-text-select"
              (click)="changeDiningDate('next')"
              [class.disabledArrow]="currentFromDate >= diningMaxDate || !(bookingTypeMaxDate | dateCompareByDay: currentFromDate) || !showNextArrow">&#62;</div>
          </div>
          <ng-container *ngFor="let cover of coverTypes;let i=index;">
            <div class="dining-input-options p-2 mb-3 d-flex justify-content-center">
              <div class="px-3 d-flex align-items-center cursor dining-select-prev-date disable-text-select"
                (click)="changeCoverTypeSize('prev', i)" [class.disabledArrow]="cover.value === 0">&#45;</div>
              <div class="d-flex flex-column">
                <div class="dining-input-placeholder activity-description-bolder text-uppercase text-center">
                  {{cover.name}}</div>
                <div class="cursor dining-selected-data activity-description text-center"
                  (click)="coverTypeSelect.open()">
                  {{cover.value}}</div>
                <mat-form-field appearance="outline" style="width:160px;height:1px;visibility: hidden;">
                  <mat-label>{{cover.name}}</mat-label>
                  <mat-select [(ngModel)]="cover.value" #coverTypeSelect
                    (ngModelChange)="checkSessionorSlotAvailability(false, true)">
                    <mat-option [value]="0">{{'0' | translate}}</mat-option>
                    <mat-option [value]="bookingSize.id" *ngFor="let bookingSize of bookingSizeArray;">
                      {{bookingSize.value}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="px-3 d-flex align-items-center cursor dining-select-next-date disable-text-select"
                (click)="changeCoverTypeSize('next', i)" [class.disabledArrow]="cover.value === maxSizeAllowed">&#43;
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="coverTypes?.length ===0">
            <div class="dining-input-options p-2 mb-3 d-flex justify-content-center">
              <div class="px-3 d-flex align-items-center cursor dining-select-prev-date disable-text-select"
                (click)="changePartySize('prev')" [class.disabledArrow]="currentBookingSize === minSizeAllowed">&#45;
              </div>
              <div class="d-flex flex-column">
                <div class="dining-input-placeholder activity-description-bolder text-uppercase text-center">
                  {{'partySize' | translate}}</div>
                <div class="cursor dining-selected-data activity-description text-center select-date-text-decoration"
                  (click)="coverTypeSelect.open()">
                  {{currentBookingSize}}</div>
                <mat-form-field appearance="outline" style="width:160px;height:1px;visibility: hidden;">
                  <mat-label>{{'partySize' | translate}}</mat-label>
                  <mat-select [(ngModel)]="currentBookingSize" #coverTypeSelect
                    (ngModelChange)="checkSessionorSlotAvailability(false, true)">
                    <mat-option [value]="bookingSize.id" *ngFor="let bookingSize of bookingSizeArray;">
                      {{bookingSize.value}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="px-3 d-flex align-items-center cursor dining-select-next-date disable-text-select"
                (click)="changePartySize('next')" [class.disabledArrow]="currentBookingSize === maxSizeAllowed">&#43;
              </div>
            </div>
          </ng-container>
          <div *ngIf="activityService.selectedDining.WidgetCustomization?.ShowCommunalTableAvailabilityOption"
            class="my-4 d-flex flex-nowrap">
            <div>
              <mat-checkbox class="chip-control__checkbox" [(ngModel)]="isCommunalTable"
                (change)="checkSessionorSlotAvailability(false, true)"></mat-checkbox>
            </div>
            <div class="px-3 activity-description-bold">{{'communalTableAvailability' | translate}}</div>
          </div>
          <div *ngIf="otherAvailableDays.length > 0" class="d-flex flex-wrap mb-3">
            <div *ngIf="!showAvailableDates" (click)="showAvailableDates=true"
              class="cursor activity-description-bold activity-list-title disable-text-select">
              {{'showAvailableDays' | translate}}
            </div>
            <ng-container *ngIf="showAvailableDates">
              <div *ngFor="let day of otherAvailableDays" (click)="chooseAvailableDate(day)" matRipple
                matRippleCentered="true" class="cursor dates-list d-flex flex-column m-2 justify-content-center"
                [ngClass]="{'dates-list-selected': checkIfDateSelected(day.value) }">
                <div class="text-center">{{day.value | localizeDate: 'DD'}}</div>
                <div class="text-center">{{day.value | localizeDate: 'ddd'}}</div>
              </div>
            </ng-container>
          </div>

          <div class="d-none d-lg-block">
            <!-- <ng-container *ngTemplateOutlet="notesDisplayContent"></ng-container>
          <ng-container *ngTemplateOutlet="promoCodeContent"></ng-container>
          <ng-container *ngTemplateOutlet="marketOptInContent"></ng-container> -->
          </div>

        </div>
        <div class="col-lg-8 col-md-12">
          <div class="d-flex flex-wrap">
            <ng-container *ngIf="seatingArea?.length > 0 && activityService?.displaySeatingArea">
              <mat-form-field class="px-2 col-sm-6 col-12" appearance="outline">
                <!-- <mat-label>{{'seatingArea' | translate}}</mat-label> -->
                <mat-select [(ngModel)]="selectedSeatingArea" name="seatingArea"
                  placeholder="{{'selectSeatingArea' | translate}}"
                  (ngModelChange)="checkSessionorSlotAvailability(false, true)">
                  <mat-option [value]="seating.id" *ngFor="let seating of seatingArea;">{{seating.value}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </ng-container>

            <ng-container *ngIf="seatingType?.length > 0 && activityService?.displaySeatingType">
              <mat-form-field class="px-2 col-sm-6 col-12" appearance="outline">
                <!-- <mat-label>{{'seatingType' | translate}}</mat-label> -->
                <mat-select [(ngModel)]="selectedSeatingType" name="seatingType"
                  placeholder="{{'selectSeatingType' | translate}}"
                  (ngModelChange)="checkSessionorSlotAvailability(false, true)">
                  <mat-option [value]="seatType.id" *ngFor="let seatType of seatingType;">{{seatType.value}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </ng-container>
          </div>
          <div *ngIf="activityService?.selectedDining?.MealTabs.length > 0" class="d-flex flex-column">
            <div class="mb-2 px-2 activity-description-bolder text-uppercase">{{'mealPeriod' | translate}}</div>
            <div class="mb-2 d-flex flex-wrap">
              <mat-chip-list selectable>
                <mat-chip class="cursor" #c="matChip" *ngFor="let option of activityService?.selectedDining?.MealTabs"
                  [selected]="option.selected" [value]="option.Id"
                  (click)="spliceTimeArrayForTheSelectedMealTab(c, option)">
                  {{option.Name}}
                </mat-chip>
              </mat-chip-list>
            </div>
          </div>
          <div class="d-flex flex-column">
            <div class="mb-2 px-2 activity-description-bolder text-uppercase">{{'timeSlots' | translate}}</div>
            <div class="d-flex flex-wrap mb-3">
              <ng-container *ngIf="!isTimeDropList">
                <ng-container *ngFor="let diningSlots of selectedDiningSlots; let i = index;">
                  <div class="p-2 col-md-2 col-sm-3 col-4 text-center" (click)="diningSlotChangeListners(diningSlots)">
                    <div class="p-2 dining-time-slot activity-description-bold"
                      [ngClass]="{'activity-time-slot-selected': diningSlots === checkedDiningLocalTime}">
                      {{diningSlots | localizeDate: 'LT'}}</div>
                  </div>
                </ng-container>
              </ng-container>
            </div>
            <ng-container *ngIf="selectedDiningSlots.length > 0 && isTimeDropList">
              <div class="d-flex justify-content-center">
                <div class="dining-input-options py-4 mb-3 col-md-6 col-sm-7 col-12 d-flex justify-content-center">
                  <div class="px-3 d-flex align-items-center cursor dining-select-prev-date disable-text-select"
                    (click)="changeTimeSlots('prev')"
                    [class.disabledArrow]="checkedDiningLocalTime === selectedDiningSlots[0]">&#60;
                  </div>
                  <div class="d-flex flex-column">
                    <div class="dining-input-placeholder activity-description-bolder text-uppercase text-center">
                      {{'time' |
                      translate}}</div>
                    <div class="cursor dining-selected-data activity-description text-center"
                      (click)="coverTypeSelect.open()">
                      {{checkedDiningLocalTime | localizeDate: 'LT'}}</div>
                    <mat-form-field appearance="outline" style="width:160px;height:1px;visibility: hidden;">
                      <mat-label>{{'time' | translate}}</mat-label>
                      <mat-select [(ngModel)]="checkedDiningLocalTime" #coverTypeSelect>
                        <mat-option (click)="diningSlotChangeListners(timing)" [value]="timing"
                          *ngFor="let timing of selectedDiningSlots;let i = index;">
                          {{timing | localizeDate: 'LT'}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="px-3 d-flex align-items-center cursor dining-select-next-date disable-text-select"
                    (click)="changeTimeSlots('next')"
                    [class.disabledArrow]="checkedDiningLocalTime === selectedDiningSlots[selectedDiningSlots.length - 1]">
                    &#62;</div>
                </div>
              </div>
            </ng-container>
          </div>
          <div class="d-block d-lg-none">
            <!-- <ng-container *ngTemplateOutlet="notesDisplayContent"></ng-container>
          <ng-container *ngTemplateOutlet="promoCodeContent"></ng-container>
          <ng-container *ngTemplateOutlet="marketOptInContent"></ng-container> -->
          </div>
          <div *ngIf="!activityService.loaderRunning && selectedDiningSlots?.length === 0"
            class="no-slots-message dining-no-data-error activity-description-bolder d-flex justify-content-center align-items-center">
            {{'noslots' | translate}}
          </div>
        </div>
      </div>


    </div>

    <div class="row" *ngIf="activityService.isNonDining">
      <div class="col-12 mt-4 d-flex flex-wrap non-dining-filters-top" *ngIf="bShowLocation">
      <div class="booking-type-field"><ng-container *ngTemplateOutlet="bookingTypeFilter"></ng-container></div>
      <div class="row mx-0">
        <div class="select-date col-12">
          <label>{{'selectDate' | translate}}</label>
        </div>
        <div class="d-flex flex-column non-dining-child-div-filters-top" id="selected-date-location-screen">
          <div class="d-flex flex-row selectable" [ngClass]="{'disable-date' : disableDatePicker}">
            <div class="cursor dining-selected-data non-dining-selected-date"
              (click)="slotEditngbPopOver?.close();frompicker.open()">
              <mat-icon class="slot-edit-icon cursor" aria-hidden="false" aria-label="edit">
                <span class="material-symbols-outlined">
                  calendar_today
                </span>
              </mat-icon>
              {{currentFromDate | localizeDate : 'Do MMMM, ddd'}}
              <mat-form-field appearance="outline" style="width:30px;height:1px;visibility: hidden;">
                <mat-label>{{'selectDate' | translate}}</mat-label>
                <input matInput placeholder="{{'selectDate' | translate}}" readonly [max]="bookingTypeMaxDate ? bookingTypeMaxDate : nonDiningMaxDate"
                  (dateChange)="changeFromDate();checkNonDiningSessionorSlotAvailability(false, true, false, true)"
                  [min]="bookingTypeMinDate ? bookingTypeMinDate : activityService.currentDateTime" [matDatepicker]="frompicker" [(ngModel)]="currentFromDate"
                  [matDatepickerFilter]="showParticularDays" [disabled]="disableDatePicker">
                <mat-datepicker-toggle class="activity-date-selector-toggle" matSuffix [for]="frompicker">
                </mat-datepicker-toggle>
                <mat-datepicker #frompicker></mat-datepicker>
              </mat-form-field>
            </div>
          </div>
        </div>

        

      </div>     

      <ng-container
          *ngIf="activityService.displayLocationType === locationViewTypes.None && selectedSeatingType">
          <mat-divider [vertical]="true"></mat-divider>

          <div class="d-flex flex-row non-dining-child-div-filters-location">
            <div class="cursor dining-selected-data non-dining-selected-date selected-location-top-bar">
              <mat-icon class="slot-edit-icon cursor" aria-hidden="false" aria-label="edit">
                <span class="material-symbols-outlined">
                  push_pin
                </span>
              </mat-icon>
              <div>
                {{seatingTypeNames[selectedSeatingType]}}
                <div class="selected-location-price-top-bar" *ngIf="rateplanSupportService.seatingTypePriceDetail[selectedSeatingType]" placement="bottom" [ngbPopover]="guestPriceSummaryByTypePopupContent">
                  {{'Price' | translate}}: ({{activityService.selectedNonDining.OperationCurrency}}{{(rateplanSupportService.seatingTypePriceDetail[selectedSeatingType]?.Total !=='' ?
                  rateplanSupportService.seatingTypePriceDetail[selectedSeatingType]?.Total : 0) | currencyDecimalFormatter}})
                </div>
                <ng-template #guestPriceSummaryByTypePopupContent>
                    <app-activites-guest-price-summary [priceDetail]="rateplanSupportService.seatingTypePriceDetail[selectedSeatingType]" [currency]="activityService.selectedNonDining.OperationCurrency"></app-activites-guest-price-summary>
                </ng-template>  
              </div>
            </div>
          </div>
      </ng-container>

        <ng-container
          *ngIf="activityService.displayLocationType !== locationViewTypes.None && selectedNonDiningSlotsDisplayText">
          <mat-divider [vertical]="true"></mat-divider>
          <div class="row mx-0">
            <div class="select-time col-12">
              <label>{{'selectTimeSlot' | translate}}</label>
            </div>
            <div class="d-flex flex-column non-dining-child-div-filters-top" id="selected-slot-display-text">
              <div class="d-flex flex-row selectable" [ngClass]="{'disable-date' : disableDatePicker}">
                <div class="cursor dining-selected-data non-dining-selected-date"
                  (click)="frompicker.close();checkSlotReloadRequired()" [ngbPopover]="EditSlotContainer"
                  placement="bottom right top left" [autoClose]="false" #slotEditngbPopOver="ngbPopover">
                  <mat-icon class="slot-edit-icon cursor" aria-hidden="false" aria-label="edit">
                    <span class="material-symbols-outlined">
                      schedule
                    </span>
                  </mat-icon>
                  {{selectedNonDiningSlotsDisplayText}}
                </div>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-container
          *ngIf="activityService.displayLocationType !== locationViewTypes.None && activityService?.selectedNonDiningLocation?.length">
          <mat-divider [vertical]="true"></mat-divider>

          <div class="d-flex flex-column non-dining-child-div-filters-top" id="selected-slot-display-text">
            <div class="d-flex flex-row non-dining-child-div-filters-location">
              <div class="cursor dining-selected-data non-dining-selected-date selected-location-top-bar">
                <mat-icon class="slot-edit-icon cursor" aria-hidden="false" aria-label="edit">
                  <span class="material-symbols-outlined">
                    push_pin
                  </span>
                </mat-icon>

                <ng-container *ngFor="let location of activityService?.selectedNonDiningLocation">
                  <div>
                    {{location.Name}}
                    <div class="selected-location-price-top-bar" *ngIf="location.PriceDetail" placement="bottom" [ngbPopover]="guestPriceSummaryPopupContent">
                      {{'TotalPriceTopBarText' | translate}}: ({{activityService.selectedNonDining.OperationCurrency}}{{(location.PriceDetail?.Total !=='' ?
                      location.PriceDetail?.Total : 0) | currencyDecimalFormatter}})
                    </div>
                  </div>
                  <ng-template #guestPriceSummaryPopupContent>
                    <app-activites-guest-price-summary [priceDetail]="location.PriceDetail" [currency]="activityService.selectedNonDining.OperationCurrency"></app-activites-guest-price-summary>
                  </ng-template>
                </ng-container>
              </div>
            </div>
          </div>
        </ng-container>

        <div class="px-2 map-legend text-uppercase"
          *ngIf="activityService.displayLocationType == locationViewTypes.LayoutView">
          <span class="ss-map-legend-values-conatainer">
            <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="legend menu">
              <mat-icon class="legend-menu-icon">category</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item class="legend-field">
                <mat-icon class="legend-icon sold">block</mat-icon>
                <!-- <span >&#8416;</span> -->
                <span>{{'Sold' | translate}}</span>
              </button>
              <button mat-menu-item class="legend-field">
                <mat-icon class="legend-icon selected">check</mat-icon>
                <!-- <span class="legend-icon selected">&#10003;</span> -->
                <span>{{'Selected' | translate}}</span>
              </button>
            </mat-menu>
          </span>
          <span class="bs-map-legend-values-conatainer">
            <!-- (click)="viewChange()" -->
            <div class="legend-field"><span class="legend-icon sold">&#8416;</span> {{'Sold' | translate}}</div>
            <div class="legend-field"><span class="legend-icon selected">&#10003;</span> {{'Selected' | translate}}
            </div>
          </span>
        </div>
      </div>

      <div class="col-12 mt-4 d-flex flex-wrap">
        <div class="col-lg-3 col-md-12 d-flex flex-column border-right non-dining-location-filters"
          id="non-dining-filters-left-side" *ngIf="bShowLocation">  

          <ng-container> 
            <size-mapping [coverTypes]="coverTypes" [bookingTypes]="bookingTypes" [maxSize]="maxSizeAllowed" [(size)]="sizeMapping" (sizeChange)="bookingSizeChange()" [dataCovers]="selectedActivityData?.CoverTypeQuantities || []" [dataSize]="currentBookingSize" [isEdit]="isEdit"></size-mapping>
          </ng-container>
       
          <!-- <ng-container *ngTemplateOutlet="nonDiningPartySizeField"></ng-container>

          <ng-container *ngTemplateOutlet="nonDiningCoverAndBookingTypeFields"></ng-container> -->

          <ng-container *ngIf="seatingArea?.length > 0 && activityService?.displaySeatingArea">
            <div class="d-flex flex-column non-dining-child-div-filters-top" id="seating-area-container">
              <div class="d-flex flex-column" id="full-width">
                <!-- (ngModelChange)="checkNonDiningSessionorSlotAvailability(false, true)" -->
                <mat-form-field class="px-2 col-sm-6 col-12" id="full-width" class="seating-fields"
                  appearance="outline">
                  <mat-label>{{'seatingArea' | translate}}</mat-label>
                  <mat-select [(ngModel)]="selectedSeatingArea" name="seatingArea"
                    placeholder="{{'selectSeatingArea' | translate}}"
                    (ngModelChange)="seatingArea_TypeFieldChangeHandler(selectedSeatingArea, false, true)">
                    <mat-option [value]="null">{{'NA' | translate}}</mat-option>
                    <mat-option [value]="seating.id" *ngFor="let seating of seatingArea;">{{seating.value}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </ng-container>


          <div class="d-flex flex-column non-dining-child-div-filters-top" id="seating-type-container"
            *ngIf="activityService?.displaySeatingType">
            <div class="d-flex flex-column" id="full-width">

              <p>{{'seatingType' | translate}}</p>

              <ng-container *ngFor="let seatType of seatingType;">
                <div class="seating-type-card cursor-pointer" *ngIf="!seatType.isHide"
                  (click)="seatingArea_TypeFieldChangeHandler(seatType, true, true)"
                  [ngClass]="{'activity-time-slot-selected': selectedSeatingType == seatType.id}">
                  <div class="seating-type-color" [style.background-color]="seatType.color">

                  </div>
                  <div class="seating-type-label">
                    {{ seatType.value }}
                  </div>
                </div>
              </ng-container>

            </div>
          </div>

        </div>

        <div class="col-lg-4 col-md-12 d-flex flex-column" *ngIf="!bShowLocation">
          <ng-container  *ngTemplateOutlet="bookingTypeFilter"></ng-container>
          <div class="dining-input-options p-2 mb-3 d-flex justify-content-center">
            <div class="px-3 d-flex align-items-center cursor dining-select-prev-date disable-text-select"
              (click)="changeNonDiningDate('prev')"
              [class.disabledArrow]="currentFromDate <= activityService.currentDateTime">&#60;</div>
            <div class="d-flex flex-column">
              <div class="dining-input-placeholder activity-description-bolder text-uppercase text-center">{{'date' |
                translate}}</div>
              <div class="cursor dining-selected-data activity-description text-center" (click)="frompicker.open()">
                {{currentFromDate | localizeDate : 'DD MMMM, ddd'}}</div>
              <mat-form-field appearance="outline" style="width:160px;height:1px;visibility: hidden;">
                <mat-label>{{'selectDate' | translate}}</mat-label>
                <input matInput placeholder="{{'selectDate' | translate}}" readonly [max]="bookingTypeMaxDate ? bookingTypeMaxDate : nonDiningMaxDate"
                  (dateChange)="changeFromDate();checkNonDiningSessionorSlotAvailability(false, true)"
                  [min]="bookingTypeMinDate ? bookingTypeMinDate : activityService.currentDateTime" [matDatepicker]="frompicker" [(ngModel)]="currentFromDate"
                  [matDatepickerFilter]="showParticularDays" [disabled]="disableDatePicker">
                <mat-datepicker-toggle class="activity-date-selector-toggle" matSuffix [for]="frompicker">
                </mat-datepicker-toggle>
                <mat-datepicker #frompicker></mat-datepicker>
              </mat-form-field>
            </div>
            <div class="px-3 d-flex align-items-center cursor dining-select-next-date disable-text-select"
              (click)="changeNonDiningDate('next')" [class.disabledArrow]="currentFromDate >= nonDiningMaxDate">&#62;
            </div>
          </div>

          <!-- <ng-container *ngIf="coverTypes?.length">
          <ng-container *ngFor="let cover of coverTypes;let i=index;">
            <div class="dining-input-options p-2 mb-3 d-flex justify-content-center">
              <div class="px-3 d-flex align-items-center cursor dining-select-prev-date disable-text-select" (click)="changeNonDiningCoverTypeSize('prev', i)"
                [class.disabledArrow]="cover.value === 0">&#45;</div>
              <div class="d-flex flex-column">
                <div class="dining-input-placeholder activity-description-bolder text-uppercase text-center">{{cover.name}}</div>
                <div class="cursor dining-selected-data activity-description text-center" (click)="coverTypeSelect.open()">
                  {{cover.value}}</div>
                <mat-form-field appearance="outline" style="width:160px;height:1px;visibility: hidden;">
                  <mat-label>{{cover.name}}</mat-label>
                  <mat-select [(ngModel)]="cover.value" #coverTypeSelect
                    (ngModelChange)="checkNonDiningSessionorSlotAvailability(false, true)">
                    <mat-option [value]="0">{{'0' | translate}}</mat-option>
                    <mat-option [value]="bookingSize.id" *ngFor="let bookingSize of bookingSizeArray;">
                      {{bookingSize.value}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="px-3 d-flex align-items-center cursor dining-select-next-date disable-text-select" (click)="changeNonDiningCoverTypeSize('next', i)"
                [class.disabledArrow]="cover.value === maxSizeAllowed">&#43;</div>
            </div>
          </ng-container>
        </ng-container> -->

        <ng-container>
          <size-mapping [coverTypes]="coverTypes" [bookingTypes]="bookingTypes" [maxSize]="maxSizeAllowed" [(size)]="sizeMapping" (sizeChange)="bookingSizeChange()" [dataCovers]="selectedActivityData?.CoverTypeQuantities || []" [dataSize]="currentBookingSize" [isEdit]="isEdit"></size-mapping>
        </ng-container>

          <!-- <ng-container *ngTemplateOutlet="nonDiningCoverAndBookingTypeFields"></ng-container> -->

          <!-- <ng-container *ngIf="coverTypes?.length ===0">
            <div class="dining-input-options p-2 mb-3 d-flex justify-content-center">
              <div class="px-3 d-flex align-items-center cursor dining-select-prev-date disable-text-select"
                (click)="changeNonDiningPartySize('prev')" [class.disabledArrow]="currentBookingSize === 0">&#45;</div>
              <div class="d-flex flex-column">
                <div class="dining-input-placeholder activity-description-bolder text-uppercase text-center">
                  {{'partySize' | translate}}</div>
                <div class="cursor dining-selected-data activity-description text-center"
                  (click)="coverTypeSelect.open()">
                  {{currentBookingSize}}</div>
                <mat-form-field appearance="outline" style="width:160px;height:1px;visibility: hidden;">
                  <mat-label>{{'partySize' | translate}}</mat-label>
                  <mat-select [(ngModel)]="currentBookingSize" #coverTypeSelect
                    (ngModelChange)="checkNonDiningSessionorSlotAvailability(false, true)">
                    <mat-option [value]="0">{{'0' | translate}}</mat-option>
                    <mat-option [value]="bookingSize.id" *ngFor="let bookingSize of bookingSizeArray;">
                      {{bookingSize.value}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="px-3 d-flex align-items-center cursor dining-select-next-date disable-text-select"
                (click)="changeNonDiningPartySize('next')"
                [class.disabledArrow]="currentBookingSize === maxSizeAllowed">&#43;</div>
            </div>
          </ng-container> -->

          <ng-container *ngTemplateOutlet="nonDiningDurationField"></ng-container>

          <ng-container *ngIf="seatingArea?.length > 0 && activityService?.displaySeatingArea">
            <div class="dining-input-options p-2 mb-3 d-flex justify-content-center">
              <div class="d-flex flex-column" id="full-width">
                <div class="dining-input-placeholder activity-description-bolder text-uppercase text-center">
                  {{'seatingArea' |
                  translate}}</div>
                <mat-form-field class="px-2 col-sm-6 col-12" id="full-width" class="seating-fields" appearance="fill">
                  <!-- <mat-label>{{'seatingArea' | translate}}</mat-label> -->
                  <mat-select [(ngModel)]="selectedSeatingArea" name="seatingArea"
                    placeholder="{{'selectSeatingArea' | translate}}"
                    (ngModelChange)="checkNonDiningSessionorSlotAvailability(false, true)">
                    <mat-option [value]="null">{{'NA' | translate}}</mat-option>
                    <mat-option [value]="seating.id" *ngFor="let seating of seatingArea;">{{seating.value}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </ng-container>


          <ng-container *ngIf="seatingType?.length > 0 && activityService?.displaySeatingType">
            <div class="dining-input-options p-2 mb-3 d-flex justify-content-center">
              <div class="d-flex flex-column" id="full-width">
                <div class="dining-input-placeholder activity-description-bolder text-uppercase text-center">
                  {{'seatingType' |
                  translate}}</div>
                <mat-form-field class="px-2 col-sm-6 col-12" id="full-width" class="seating-fields" appearance="fill">
                  <!-- <mat-label>{{'seatingType' | translate}}</mat-label> -->
                  <mat-select [(ngModel)]="selectedSeatingType" name="seatingType"
                    placeholder="{{'selectSeatingType' | translate}}"
                    (ngModelChange)="checkNonDiningSessionorSlotAvailability(false, true)">
                    <mat-option [value]="null">{{'NA' | translate}}</mat-option>
                    <mat-option [value]="seatType.id" *ngFor="let seatType of seatingType;">{{seatType.value}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </ng-container>


          <div *ngIf="activityService.selectedNonDining.WidgetCustomization?.ShowCommunalTableAvailabilityOption"
            class="my-4 d-flex flex-nowrap">
            <div>
              <mat-checkbox class="chip-control__checkbox" [(ngModel)]="isCommunalTable"
                (change)="checkNonDiningSessionorSlotAvailability(false, true)"></mat-checkbox>
            </div>
            <div class="px-3 activity-description-bold">{{'communalTableAvailability' | translate}}</div>
          </div>
          <div *ngIf="otherAvailableDays.length > 0" class="d-flex flex-wrap mb-3">
            <div *ngIf="!showAvailableDates" (click)="showAvailableDates=true"
              class="cursor activity-description-bold activity-list-title disable-text-select">
              {{'showAvailableDays' | translate}}
            </div>
            <ng-container *ngIf="showAvailableDates">
              <div *ngFor="let day of otherAvailableDays" (click)="chooseAvailableDate(day)" matRipple
                matRippleCentered="true" class="cursor dates-list d-flex flex-column m-2 justify-content-center"
                [ngClass]="{'dates-list-selected': checkIfDateSelected(day.value) }">
                <div class="text-center">{{day.value | localizeDate: 'DD'}}</div>
                <div class="text-center">{{day.value | localizeDate: 'ddd'}}</div>
              </div>
            </ng-container>
          </div>

          <div class="d-none d-lg-block">
            <!-- <ng-container *ngTemplateOutlet="notesDisplayContent"></ng-container>
          <ng-container *ngTemplateOutlet="promoCodeContent"></ng-container>
          <ng-container *ngTemplateOutlet="marketOptInContent"></ng-container> -->
          </div>

        </div>
        <div class="col-lg-8 col-md-12" *ngIf="activityService.displayLocationType == locationViewTypes.None">
          <ng-container *ngIf="isMultiSlotSelection">
            <ng-container *ngTemplateOutlet="nonDiningDurationField"></ng-container>
          </ng-container>
          <ng-container *ngTemplateOutlet="nonDiningTimeSlots"></ng-container>
        </div>
        
        <ng-container *ngIf="selectedNonDiningSlots?.length && matchedContinousSlots?.length">

          <div *ngIf="floorPlan && activityService.displayLocationType == locationViewTypes.LayoutView"
            class="col-lg-9 col-md-12 pd-r0">
            <activities-layout [floorPlan]="floorPlan" [currentBookingSize]="overAllBookingSize"
              [seatingTypeList]="seatingTypesMasterList" [updateIndicator]="updateIndicator"
              [selectedSeatingType]="selectedSeatingType"
              (locationSelection)="locationSelectionInMapHandler($event)"
              [currentFromDate]="currentFromDate" [matchedContinousSlots]="matchedContinousSlots" [duration]="durationControl.value" [sizeMapping]="sizeMapping"
              [restaurantId]="route.snapshot.params.restaurantId"></activities-layout>
          </div>

          <div class="col-lg-9 col-md-12 pd-r0 location-list-parent-conatiner"
            *ngIf="bShowLocation && activityService.displayLocationType == locationViewTypes.ListView">
            <div>
              <ng-container *ngFor="let location of activityService?.selectedNonDiningLocation">
                  <div class="selected-location-price-top-bar" *ngIf="location.Price" placement="bottom" [ngbPopover]="guestPriceSummaryPopupContent">
                    {{'Price' | translate}}: ({{activityService.selectedNonDining.OperationCurrency}}{{(location.PriceDetail?.Total !=='' ?
                    location.PriceDetail?.Total : 0) | currencyDecimalFormatter}})
                  </div>
                <ng-template #guestPriceSummaryPopupContent>
                  <app-activites-guest-price-summary [priceDetail]="location.PriceDetail" [currency]="activityService.selectedNonDining.OperationCurrency"></app-activites-guest-price-summary>
                </ng-template>
              </ng-container>
            </div>
            <div class="d-flex flex-column">
              <div class="mb-2 px-2 activity-description-bolder text-uppercase location-list-header">{{'Locations' |
                translate}}</div>
              <div class="d-flex flex-wrap mb-3 location-list-container">
                <ng-container *ngIf="!isTimeDropList">
                  <ng-container *ngFor="let table of filteredTableList; let i = index;">
                    <div class="p-2 col-md-4 col-sm-5 col-6 text-center" (click)="locationViewSelectionEventHandler(table)">
                      <div class="p-2 dining-time-slot location-card activity-description-bold"
                        [style.border-left-color]="table.seatingTypeColor ? table.seatingTypeColor : 'none'"
                        [ngClass]="{'activity-time-slot-selected': table.isSelected}">
                        <ng-container *ngIf="table.isSelected">
                          <ng-container *ngTemplateOutlet="selectedIcon"></ng-container>
                        </ng-container>
                        {{table.Name}}
                       
                        <div class="location-size-container" *ngIf="activityService.validateLocationSize">
                          {{'Min'}}: {{table.MinPartySize}} {{'Max'}}: {{table.MaxPartySize}}
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </ng-container>
              </div>
            </div>
            <div class="d-block d-lg-none">
              <!-- <ng-container *ngTemplateOutlet="notesDisplayContent"></ng-container>
            <ng-container *ngTemplateOutlet="promoCodeContent"></ng-container>
            <ng-container *ngTemplateOutlet="marketOptInContent"></ng-container> -->
            </div>
            <div *ngIf="!activityService.loaderRunning && filteredTableList?.length === 0"
              class="no-slots-message dining-no-data-error activity-description-bolder d-flex justify-content-center align-items-center">
              {{'noLocations' | translate}}
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="selectedNonDiningSlots?.length && !matchedContinousSlots?.length">
          <div
            class="col-lg-9 no-slots-message dining-no-data-error activity-description-bolder d-flex justify-content-center align-items-center">
            {{'PleaseSelectTimeSlotsToShowTheTablesOrSeating' | translate}}
          </div>
        </ng-container>
        <ng-container *ngIf="!selectedNonDiningSlots?.length && !matchedContinousSlots?.length">
          <div
            class="col-lg-9 no-slots-message dining-no-data-error activity-description-bolder d-flex justify-content-center align-items-center">
            {{'unavailableForSelectionInfo' | translate}}
          </div>
        </ng-container>

      </div>


    </div>

    <div class="confirm-button-section col-12 mt-5">
      <div class="d-flex flex-wrap justify-content-around"
        *ngIf="activityService.isNonDining && (!bShowLocation || activityService.displayLocationType == locationViewTypes.None) ">
        <button mat-button type="button"
          class="my-3 activity-buttons activity-confirm-buttons text-center text-uppercase"
          [disabled]="!validGroupSize || !checkedItem || !checkedNonDiningLocalTime || disableDatePicker" (click)="navigateGuestData()">
          <!-- (click)="showHideLocationEventHandler()" -->
          {{'continue' | translate}}
        </button>
      </div>
      <div class="d-flex flex-wrap justify-content-around"
        *ngIf="activityService.isNonDining && bShowLocation && activityService.displayLocationType !== locationViewTypes.None">
        <button mat-button type="button"
          class="my-3 activity-buttons activity-confirm-buttons text-center text-uppercase"
          [disabled]="!validGroupSize || !checkedItem || activityService.nonDiningTotalSeatsSelected != overAllBookingSize || disableDatePicker"
          (click)="navigateGuestData()">
          {{'continue' | translate}}
        </button>
      </div>
    </div>

    <div class="confirm-button-section col-12 mt-5" *ngIf="!activityService.isNonDining">
      <div class="d-flex flex-wrap justify-content-around">
        <button mat-button type="button"
          class="my-3 activity-buttons activity-confirm-buttons text-center text-uppercase"
          [disabled]="!validGroupSize || !checkedItem" (click)="navigateGuestData()">
          {{'continue' | translate}}
        </button>
      </div>
    </div>

  </div>
</ng-container>
<ng-container *ngIf="activityService.showGuestFields">
  <div class="container">
    <div class="confirm-button-section col-12 mt-5">
      <div class="d-flex flex-wrap justify-content-around">
        <button mat-button type="button" [disabled]="!guestContactValidation || finishReservationClicked "
          class="my-3 activity-buttons activity-confirm-buttons text-center text-uppercase"
          (click)="proceedMultiBooking(true)">
          {{'finishReservation' | translate}}
        </button>
        <button *ngIf="!isEdit" mat-button type="button" (click)="addToCart()" [disabled]="!guestContactValidation "
          class="my-3 activity-buttons activity-confirm-buttons text-center text-center text-uppercase">
          {{'AddToCart' | translate}}
        </button>
      </div>
    </div>
    <div class="confirm-button-section col-12 mt-5">
      <div class="d-flex flex-wrap justify-content-around">
        <button mat-button type="button"
          class="my-3 activity-buttons activity-confirm-buttons text-center text-uppercase"
          (click)="backToSlotSelect()">
          {{'Back' | translate}}
        </button>
      </div>
    </div>
  </div>
</ng-container>
<ng-template #notesDisplayContent>
  <!-- Enable when Notes is added for Activities -->
  <!-- <ng-container *ngFor="let notes of notesOptions">
    <div *ngIf="notes.text" class="activity-description-bolder text-uppercase">
      {{notes.text}}
    </div>
    <div class="d-flex flex-row">
      <mat-chip-list selectable multiple>
        <mat-chip class="cursor" #c="matChip" *ngFor="let option of notes.checkBoxOptions" [selected]="option.selected"
          [value]="option.value" (click)="toggleSelection(c, option)">
          <mat-icon class="chip-check-icon" *ngIf="c.selected">check</mat-icon>
          {{option.value}}
        </mat-chip>
      </mat-chip-list>
    </div>
    <div *ngIf="notes.commentsBox?.id && !activityService.isDining" class="pt-2" style="font-size: 13px;color: #585252">Note: Please specify the party that you are joining</div>
    <div *ngIf="notes.commentsBox?.id" class="pt-2 d-flex flex-row">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Leave a comment</mat-label>
        <textarea [(ngModel)]="notes.commentsBox.value" matInput placeholder="Add your comments here"></textarea>
      </mat-form-field>
    </div>
  </ng-container> -->
</ng-template>

<ng-template #promoCodeContent>
  <div *ngIf="activityService.selectedDining.WidgetCustomization?.DisplayPromoCode">
    <mat-form-field appearance="outline">
      <mat-label>{{activityService.selectedDining.WidgetCustomization?.PromoCodeLabel ?
        activityService.selectedDining.WidgetCustomization?.PromoCodeLabel : ('promoCode' | translate)}}</mat-label>
      <input matInput type="text"
        placeholder="{{activityService.selectedDining.WidgetCustomization?.PromoCodeLabel ? activityService.selectedDining.WidgetCustomization?.PromoCodeLabel : ('promoCode' | translate)}}"
        [(ngModel)]="promoCodeDetail" name="promoCode" />
    </mat-form-field>
  </div>
</ng-template>

<ng-template #marketOptInContent>
  <div *ngIf="activityService.selectedDining.MarketingFlagEnabled" class="my-4 d-flex flex-nowrap">
    <div>
      <mat-checkbox class="chip-control__checkbox" [(ngModel)]="marketingFlag"></mat-checkbox>
    </div>
    <div class="px-3 activity-description-bold">{{activityService.selectedDining.MarketingFlagDescription}}</div>
  </div>
</ng-template>



<!-- (click) = "$event.stopPropagation()" -->
<ng-template #EditSlotContainer>
  <div class="edit-slot-content">
    <button class="close-icon-button" aria-label="close" (click)="closeSlotEditPopOver()">
      <mat-icon>close</mat-icon>
    </button>
    <div class="non-dining-duration-popover-field-container" *ngIf="isMultiSlotSelection">
      <ng-container *ngTemplateOutlet="nonDiningDurationField"></ng-container>
    </div>
    <div class="col-lg-12 col-md-12 non-dining-duration-popover-slot-container">
      <ng-container *ngTemplateOutlet="nonDiningTimeSlots"></ng-container>
    </div>
  </div>
</ng-template>

<ng-template #nonDiningDurationField>
  <div class="dining-input-options p-2 mb-3 d-flex justify-content-center"
    [ngClass]="{ 'wd-40 auto-assignment-duration-field': activityService.displayLocationType == locationViewTypes.None }">
    <div class="px-3 d-flex align-items-center cursor dining-select-prev-date disable-text-select"
      (click)="changeNonDiningDuration('prev')" [class.disabledArrow]="durationControl.value <= TimeSlotUnitInMinutes">
      &#45;</div>
    <div class="d-flex flex-column">
      <div class="dining-input-placeholder activity-description-bolder text-uppercase text-center"
        *ngIf="!bShowLocation || activityService.displayLocationType == locationViewTypes.None">{{'Duration' |
        translate}}</div>
      <div class="cursor dining-selected-data activity-description text-center">
        <mat-form-field class="px-2 col-sm-6 col-12" id="full-width" class="input-border-bottom seating-fields"
          appearance="fill">
          <mat-label
            *ngIf="bShowLocation && activityService.displayLocationType !== locationViewTypes.None">{{'Duration' |
            translate}}</mat-label>
          <input type="number" class="duration-input-field" matInput [formControl]="durationControl"
            [matAutocomplete]="auto" [durationList]="durationList" appDurationValue>
          <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
            <mat-option *ngFor="let option of filteredDurationOptions | async" [value]="option"
              (click)="setDurationControlValue(option);">
              {{option.displayName}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>
    </div>
    <div class="px-3 d-flex align-items-center cursor dining-select-next-date disable-text-select"
      (click)="changeNonDiningDuration('next')"
      [class.disabledArrow]="durationControl.value >= durationList[durationList.length-1]">&#43;</div>
  </div>
</ng-template>

<ng-template #nonDiningTimeSlots>
  <div class="d-flex flex-column">
    <div class="mb-2 px-2 activity-description-bolder text-uppercase slot-list-header">{{'timeSlots' | translate}}</div>
    <div class="d-flex flex-wrap mb-3 slot-list-container">
      <ng-container *ngIf="!isTimeDropList">
        <ng-container *ngFor="let nonDiningSlots of selectedNonDiningSlots; let i = index;">
          <div class="p-2 col-md-2 col-sm-3 col-4 text-center" (click)="nonDiningSlotChangeListners(nonDiningSlots)">
            <div class="p-2 dining-time-slot activity-description-bold"
              [ngClass]="{'activity-time-slot-selected': highlightSelectedNonDiningSlots(nonDiningSlots)}">
              {{nonDiningSlots | localizeDate: 'LT'}}</div>
          </div>
        </ng-container>
      </ng-container>
    </div>
    <ng-container *ngIf="selectedNonDiningSlots.length > 0 && isTimeDropList">
      <div class="d-flex justify-content-center">
        <div class="dining-input-options py-4 mb-3 col-md-6 col-sm-7 col-12 d-flex justify-content-center">
          <div class="px-3 d-flex align-items-center cursor dining-select-prev-date disable-text-select"
            (click)="changeNonDiningTimeSlots('prev')"
            [class.disabledArrow]="checkedNonDiningLocalTime === selectedNonDiningSlots[0]">&#60;
          </div>
          <div class="d-flex flex-column">
            <div class="dining-input-placeholder activity-description-bolder text-uppercase text-center">{{'time' |
              translate}}</div>
            <div class="cursor dining-selected-data activity-description text-center" (click)="coverTypeSelect.open()">
              {{checkedNonDiningLocalTime | localizeDate: 'LT'}}</div>
            <mat-form-field appearance="outline" style="width:160px;height:1px;visibility: hidden;">
              <mat-label>{{'time' | translate}}</mat-label>
              <mat-select [(ngModel)]="checkedNonDiningLocalTime" #coverTypeSelect>
                <mat-option (click)="nonDiningSlotChangeListners(timing)" [value]="timing"
                  *ngFor="let timing of selectedNonDiningSlots;let i = index;">
                  {{timing | localizeDate: 'LT'}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="px-3 d-flex align-items-center cursor dining-select-next-date disable-text-select"
            (click)="changeNonDiningTimeSlots('next')"
            [class.disabledArrow]="checkedNonDiningLocalTime === selectedNonDiningSlots[selectedNonDiningSlots.length - 1]">
            &#62;</div>
        </div>
      </div>
    </ng-container>
  </div>
  <div class="d-block d-lg-none">
    <!-- <ng-container *ngTemplateOutlet="notesDisplayContent"></ng-container>
    <ng-container *ngTemplateOutlet="promoCodeContent"></ng-container>
    <ng-container *ngTemplateOutlet="marketOptInContent"></ng-container> -->
  </div>
  <div *ngIf="!activityService.loaderRunning && selectedNonDiningSlots?.length === 0"
    class="no-slots-message dining-no-data-error activity-description-bolder d-flex justify-content-center align-items-center">
    {{'noslots' | translate}}
  </div>
</ng-template>


<ng-template #selectedIcon>
  <mat-icon class="legend-icon selected">check</mat-icon>
</ng-template>

<ng-template #nonDiningPartySizeField>

  <div *ngIf="!coverTypes?.length && !bookingTypes?.length"
    class="dining-input-options type-input-field-options p-2 mb-3 d-flex justify-content-center booking-type-fields">
    <div class="wd-60 type-field-headers activity-description-bolder">{{ 'partySize' | translate }}</div>
    <div class="wd-40">
      <div
        class="type-field-minus-icon wd-35 d-flex align-items-center cursor dining-select-prev-date disable-text-select"
        (click)="changeNonDiningPartySize('prev')" [class.disabledArrow]="currentBookingSize === 0">&#45;</div>
      <div class="wd-30 d-flex">
        <mat-form-field class="input-border-bottom seating-fields text-align-center" id="full-width">


          <input type="number" [(ngModel)]="currentBookingSize"
            (ngModelChange)="checkNonDiningSessionorSlotAvailability(false, true);updateSlotReloadValue()" matInput
            [matAutocomplete]="auto">
          <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
            <mat-option [value]=0>{{'0' | translate}}</mat-option>
            <mat-option [value]="bookingSize.id" *ngFor="let bookingSize of bookingSizeArray;">
              {{bookingSize.value}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>
      <div
        class="type-field-plus-icon wd-35 d-flex align-items-center cursor dining-select-next-date disable-text-select"
        (click)="changeNonDiningPartySize('next')" [class.disabledArrow]="currentBookingSize === maxSizeAllowed">&#43;
      </div>
    </div>
  </div>

</ng-template>


<ng-template #nonDiningCoverAndBookingTypeFields>

  <ng-container *ngIf="coverTypes?.length || bookingTypes?.length">

    <h4 class="cover-booking-types-titles" *ngIf="bookingTypes?.length">{{ 'BookingTypes' | translate }}</h4>

    <ng-container *ngFor="let bookType of bookingTypes;let i=index;">
      <div
        class="dining-input-options type-input-field-options p-2 mb-3 d-flex justify-content-center booking-type-fields">
        <div class="wd-60 type-field-headers">{{bookType.name}}</div>
        <div class="wd-40">
          <div
            class="type-field-minus-icon wd-35 d-flex align-items-center cursor dining-select-prev-date disable-text-select"
            (click)="changeNonDiningBookingTypeSize('prev', i)" [class.disabledArrow]="bookType.value === 0">&#45;</div>
          <div class="wd-30 d-flex">
            <mat-form-field class="input-border-bottom seating-fields text-align-center" id="full-width">

              <input type="number" [(ngModel)]="bookType.value" name="bookType_{{i}}"
                (ngModelChange)="checkNonDiningSessionorSlotAvailability(false, true)" matInput
                [matAutocomplete]="auto">
              <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
                <mat-option [value]=0>{{'0' | translate}}</mat-option>
                <mat-option [value]="bookingSize.id" *ngFor="let bookingSize of bookingSizeArray;">
                  {{bookingSize.value}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
          <div
            class="type-field-plus-icon wd-35 d-flex align-items-center cursor dining-select-next-date disable-text-select"
            (click)="changeNonDiningBookingTypeSize('next', i)"
            [class.disabledArrow]="bookType.value === maxSizeAllowed">&#43;</div>
        </div>
      </div>
    </ng-container>

    <h4 class="cover-booking-types-titles" *ngIf="coverTypes?.length">{{ 'CoverTypes' | translate }}</h4>

    <ng-container *ngFor="let cover of coverTypes;let i=index;">
      <div
        class="dining-input-options type-input-field-options p-2 mb-3 d-flex justify-content-center booking-type-fields">
        <div class="wd-60 type-field-headers">{{cover.Name || cover.name}}</div>
        <div class="wd-40">
          <div
            class="type-field-minus-icon wd-35 d-flex align-items-center cursor dining-select-prev-date disable-text-select"
            (click)="changeNonDiningCoverTypeSize('prev', i)" [class.disabledArrow]="cover.value === 0">&#45;</div>
          <div class="wd-30 d-flex">
            <mat-form-field class="input-border-bottom seating-fields text-align-center" id="full-width">
              <!-- <mat-label>{{cover.Name}}</mat-label> -->



              <input type="number" [(ngModel)]="cover.value" name="cover_{{i}}"
                (ngModelChange)="checkNonDiningSessionorSlotAvailability(false, true)" matInput
                [matAutocomplete]="auto">
              <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
                <mat-option [value]=0>{{'0' | translate}}</mat-option>
                <mat-option [value]="bookingSize.id" *ngFor="let bookingSize of bookingSizeArray;">
                  {{bookingSize.value}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
          <div
            class="type-field-plus-icon wd-35 d-flex align-items-center cursor dining-select-next-date disable-text-select"
            (click)="changeNonDiningCoverTypeSize('next', i)" [class.disabledArrow]="cover.value === maxSizeAllowed">
            &#43;</div>
        </div>
      </div>
    </ng-container>

  </ng-container>

</ng-template>

<ng-template #bookingTypeFilter>
  <ng-container *ngIf="bookingTypeList?.length" >
  <div >
    <mat-form-field class="px-2 col-sm-6 col-12" id="full-width" class="seating-fields"
            appearance="outline">
            <mat-label>{{'selectBookingType' | translate}}</mat-label>
            <mat-select [(ngModel)]="selectedBookingType" name="bookingType"
              placeholder="{{'selectSeatingArea' | translate}}"
              (ngModelChange)="bookingTypeChangeHandler()">
              <mat-option [value]="type.id" *ngFor="let type of bookingTypeList;">{{type.value}}
              </mat-option>
            </mat-select>
          </mat-form-field>
  </div>
  <div [hidden]="selectedBookingType == BookingGuestType.Others"> 
    <mat-form-field class="seating-fields" appearance="outline">
      <mat-label>{{bookingTypePlaceholder}}</mat-label>
      <input matInput type="text" [(ngModel)]="confirmationNumber">
      <button *ngIf="confirmationNumber" matSuffix mat-icon-button aria-label="Clear" (click)="applyBookingType()">
        <mat-icon>search</mat-icon>
      </button>
    </mat-form-field>
  </div>
</ng-container>
</ng-template>